import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import { GlobalTheme } from '~/_base/apeMuiTheme';
import { SWRConfig } from 'swr';
import { ToastProvider } from '~/_base/context/toastContext';
import App from './app';
import './errorLogging';

require('~/_base/styles/_apeMuiTheme.scss');

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('react-trial-setup')!;
  createRoot(form).render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={GlobalTheme}>
        <ToastProvider>
          <SWRConfig
            value={{
              revalidateOnFocus: false,
            }}
          >
            <App />
          </SWRConfig>
        </ToastProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
});
